import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import focusReset from '~utils/focus-reset'

interface RouteComponents {
  HomePage: typeof Vue;
  RedemptionPage: typeof Vue;
  Summary: typeof Vue;
  Payment: typeof Vue;
}

const routerBuilder = ({
  HomePage, RedemptionPage, Summary, Payment,
}: RouteComponents): VueRouter => {
  Vue.use(VueRouter)

  const routes: RouteConfig[] = [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/redemption',
      component: RedemptionPage,
      children: [
        {
          path: '',
          name: 'redemption-summary',
          component: Summary,
        },
        {
          path: 'payment',
          name: 'redemption-payment',
          component: Payment,
        },
      ],
    },
    {
      path: '*',
      redirect: { name: 'home' },
    },
  ]

  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { x: 0, y: 0 }
    },
  })

  router.afterEach(() => {
    focusReset('focusResetAnchor')
  })

  return router
}

export default routerBuilder
